import { Box, Button, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Divider from '@mui/material/Divider'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { makeGetRequest } from 'utils/api'
import moment from 'moment'
import { toast } from 'react-toastify'
import { makePostRequest } from 'utils/api'
import CreateTask from './CreateTask'
import CreateEvent from './CreateEvent'

export default function Offer() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [joblist, setJobList] = useState([])
  const [filterJoblist, setFilterJobList] = useState([])
  const [selectedJob, setSelectedJob] = useState(false)
  const [createTache, setCreateTache] = useState(false)
  const [createEvent, setCreateEvent] = useState(false)

  useEffect(() => {
    getJobList()
  }, [])

  const handleJob = async (job, status) => {
    const payload = { id: job.id, status: status }
    const res = await makePostRequest('/api/Professional/jobs-status/', payload, {}, true)
    if (res.status === 200) {
      toast(`${job.title} successfully ${status}`, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        theme: 'dark',
        pauseOnFocusLoss: false,
      })
    }
  }
  const getJobList = async () => {
    const res = await makeGetRequest('/api/Professional/jobs/', {}, true)
    if (res.status === 200) {
      setJobList(res.data)
      setFilterJobList(res.data)
    }
  }
  const handleInputChange = (event) => {
    let query = event.target.value
    if (query !== '') {
      setFilterJobList(joblist.filter((el) => el.title.toLowerCase().includes(query.toLowerCase())))
    } else {
      setFilterJobList(joblist)
    }
  }
  const handleCreateTask = () => {
    setCreateTache(true)
  }
  const handleCreateEvent = () => {
    setCreateEvent(true)
  }
  const toggleModal = () => {
    setCreateEvent(false)
  }
  return (
    <>
      {createEvent && <CreateEvent toggleModal={toggleModal} title={selectedJob.title} />}
      {createTache && <CreateTask setCreateTache={setCreateTache} title={selectedJob.title} />}
      <Box display={'flex'}>
        <Box minWidth={390} height={'82vh'} p={1}>
          <Box fontSize={'larger'} fontWeight={'600'}>
            {t('opportunities.titleJobOffers') /* LAP-733 (GE022) */} ({filterJoblist.length})
          </Box>
          <Box width={'100%'} py={2}>
            <input
              onChange={handleInputChange}
              placeholder={t('opportunities.placeholderLocation') /* LAP-733 (GE022) */}
              style={{ width: '100%', borderRadius: 10, padding: '2px 10px' }}
            />
          </Box>
          {filterJoblist.length > 0 ? (
            <List sx={{ width: '100%' }}>
              {filterJoblist.map((job, index) => (
                <ListItem
                  key={index}
                  alignItems="flex-start"
                  sx={{
                    borderBottom: '1px solid gray',
                    px: 1,
                    cursor: 'pointer',
                    background: selectedJob && selectedJob.id === job.id ? '#80808040' : '',
                  }}
                  onClick={() => setSelectedJob(job)}
                >
                  <ListItemAvatar>
                    <img src="/jobpic.png" alt="" style={{ height: 70 }} />
                  </ListItemAvatar>
                  <ListItemText
                    sx={{ '.MuiTypography-body1': { fontSize: 20, fontWeight: 700 } }}
                    primary={job.title}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'white', display: 'inline' }}
                        >
                          {job.company_name}
                        </Typography>
                        <Box color={'gray'}>{job.location}</Box>
                        <Box color={'gray'} mt={1}>
                          {moment(job.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                        </Box>
                      </>
                    }
                  />
                  <ListItemAvatar>
                    <MarkAsUnreadIcon />
                    <BookmarkIcon />
                  </ListItemAvatar>
                </ListItem>
              ))}
            </List>
          ) : (
            <Box>{t('opportunities.noJobsFound') /* LAP-733 (GE022) */}</Box>
          )}
        </Box>
        <Box width={'100%'} px={3} py={1}>
          {selectedJob ? (
            <Box>
              <Box display={'flex'} alignItems={'center'}>
                <Box>
                  <img src="/jobpic.png" alt="" style={{ height: 70 }} />
                </Box>
                <Box sx={{ fontSize: 25, fontWeight: 700 }}>{selectedJob.company_name}</Box>
              </Box>
              <Box mt={2} fontSize={25} fontWeight={700}>
                {selectedJob.title}
              </Box>
              <Box display={'flex'} alignItems={'center'} fontSize={18}>
                <HomeRepairServiceIcon />
                <Box mt={'2px'} ml={1}>
                  {selectedJob.salary_range}
                </Box>
              </Box>
              <Box mt={2}>
                <Stack direction="row" spacing={2}>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<MarkAsUnreadIcon />}
                    onClick={() => handleJob(selectedJob, 'Postuler')}
                  >
                    {t('opportunities.btnApply') /* LAP-733 (GE022) */}
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<BookmarkIcon />}
                    onClick={() => handleJob(selectedJob, 'Enregistrer')}
                  >
                    {t('opportunities.btnSave') /* LAP-733 (GE022) */}
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<DoneAllIcon />}
                    onClick={handleCreateTask}
                  >
                    {t('opportunities.btnToDo') /* LAP-733 (GE022) */}
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<CalendarMonthIcon />}
                    onClick={handleCreateEvent}
                  >
                    {t('opportunities.btnEvent') /* LAP-733 (GE022) */}
                  </Button>
                </Stack>
              </Box>
              <Box mt={2} fontSize={25} fontWeight={700}>
                {t('opportunities.aboutOffer') /* LAP-733 (GE022) */}
              </Box>
              <Box mt={3}>{selectedJob.description}</Box>
            </Box>
          ) : (
            <Box></Box>
          )}
        </Box>
      </Box>
    </>
  )
}
